export default "__VITE_ASSET__B2TW8O5s__"